import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { buttonMarginSpace, buttonWidth } from '../../constants/form';
import { Routes } from '../../../../util/constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../../state';
import { closeModal } from '../../../../state/packingSlipPopupModalSlice';
import { useTranslation } from 'react-i18next';
import { openPackingSlipModal } from '../../../../state/packingSlipModalSlice';
import DraggablePaper from '../../DraggablePaper';

const popupFormWidth = 500;

export default function CreatePackingSlipPopupModal() {
  const { t: tGlobal } = useTranslation([], {
    keyPrefix: 'team.Global.Buttons',
  });
  const { t: tCreate } = useTranslation([], {
    keyPrefix: 'team.Modals.Packing Slips.createPopup',
  });

  const { openPackingSlipPopupModal } = useSelector(
    ({ packingSlipPopupModalSlice }) => packingSlipPopupModalSlice,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleOpenCreatePackingSlipModal = () => {
    handleClose();
    dispatch(openPackingSlipModal({ resetState: true }));
  };

  return (
    <Dialog
      open={openPackingSlipPopupModal}
      onClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      maxWidth="lg"
      scroll="paper"
      PaperProps={{ style: { width: popupFormWidth } }}
      PaperComponent={DraggablePaper}
    >
      <>
        <DialogTitle
          id="draggable-dialog-title"
          sx={{ m: 0, p: 1, cursor: 'move' }}
        >
          {tCreate('Create Packing Slip')}
        </DialogTitle>
        <IconButton
          color="primary"
          sx={{ position: 'absolute', right: 4, top: 4 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ p: 1 }}>
          <Typography align="center">
            {tCreate(
              'To avoid duplicate, it is suggested to search for existing packing slips.',
            )}
          </Typography>
          <Typography align="center">
            {tCreate('Search for existing packing slips?')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box width="100%" sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
              onClick={handleClose}
            >
              {tGlobal('Cancel')}
            </Button>
            <Box>
              <Button
                variant="outlined"
                color="primary"
                sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
                onClick={() => {
                  navigate(Routes.HOME_PACKING_SLIPS);
                  handleClose();
                }}
              >
                {tGlobal('Search')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: buttonWidth }}
                onClick={() => {
                  handleOpenCreatePackingSlipModal();
                }}
              >
                {tGlobal('Create')}
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  );
}
